import CrisisListItemDetails from './CrisisListItemDetails';

export default CrisisListItemDetails;
